import {
  Box,
  AppBar as MuiAppBar,
  Toolbar,
  Typography,
  Button,
  useTheme,
} from '@mui/material'
const SendHubLogoPath = 'assets/Logo Regular_white.png'

/* eslint-disable-next-line */
export interface AppBarProps {
  integrationsBaseUrl: string
  /**
   * onLogOut
   * Callback called when the logout button is clicked
   * The logout button is only shown if this is defined
   */
  onLogOut?: () => void
}

export function AppBar({ onLogOut, integrationsBaseUrl }: AppBarProps) {
  const theme = useTheme()
  return (
    <Box sx={{ flexGrow: 1 }}>
      <MuiAppBar position="static">
        <Toolbar>
          <a
            href="https://www.sendhub.com"
            style={{ justifyContent: 'center' }}
          >
            <img
              src={`${integrationsBaseUrl}/${SendHubLogoPath}`}
              style={{
                height: '35px',
                paddingRight: theme.spacing(2),
                marginTop: '6px',
              }}
            />
          </a>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            Integrations (Beta)
          </Typography>
          {onLogOut !== undefined ? (
            <Button variant="contained" onClick={onLogOut} color="secondary">
              Log Out
            </Button>
          ) : null}
        </Toolbar>
      </MuiAppBar>
    </Box>
  )
}

export default AppBar
